import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";

import { institucionPorId, obtenerInstituciones } from "../../Services/Rest";
import { MDBCollapse, MDBBtn } from "mdb-react-ui-kit";
import Cookies from "universal-cookie";
import EditarInstitucion from "./EditarInstitucion";
import PerfilAutoevaluacio from "./PerfilAutoevaluacion";
import InfoPerfil from "./InfoPerfil";
import * as IoIcons from "react-icons/io";
import InfoPerfilInstitucion2 from "./InfoPerfilInstitucion2";
const cookie = new Cookies();

if (cookie.get("tipo_Usuario") == 1) {
  var urlendpoint = obtenerInstituciones;
}
if (cookie.get("tipo_Usuario") == 2) {
  var urlendpoint = institucionPorId + cookie.get("institucionid");
}
if (cookie.get("tipo_Usuario") == 3) {
  var urlendpoint = obtenerInstituciones;
}
if (cookie.get("tipo_Usuario") == 4) var urlendpoint = obtenerInstituciones;

function Instituciones() {
  const [showShow, setShowShow] = useState(false);
  const toggleShow = () => setShowShow(!showShow);
  const [showShow1, setShowShow1] = useState(false);
  const toggleShow1 = () => setShowShow1(!showShow1);
  const [showShow2, setShowShow2] = useState(false);
  const toggleShow2 = () => setShowShow2(!showShow2);

  const cookies = new Cookies();
  const [list, setList] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: urlendpoint,
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList]);
  const stringCapitulo = list.map((item) => {
    return item.id;
  });
  const Id = stringCapitulo.join(
    list.map((item) => {
      return item.id;
    })
  );

  return (
    <Fragment>
      <div className="text-center">
        <div class="container-fluid">
          <div class="card shadow mb-4">
            <div class="card-header py-3">
              {cookies.get("tipo_Usuario") == 1 ? (
                <h6 class="m-0 font-weight-bold text-primary">Instituciones</h6>
              ) : (
                <h6 class="m-0 font-weight-bold text-primary">Institución</h6>
              )}
            </div>

            <div class="card-body">
              <hr />
              <MDBBtn
                outline
                className="btn btn-light btn-user btn-block"
                onClick={toggleShow}
              >
                <IoIcons.IoIosPaper />{" "}
                <left>Informacion de la Institución</left>
              </MDBBtn>
              <MDBCollapse show={showShow}>
                <div class="table-responsive">
                  <table
                    class="table table-bordered"
                    id="dataTable"
                    width="100%"
                    cellspacing="0"
                  >
                    <thead>
                      <tr>
                        <th>Id</th>
                        <th>Razon Social</th>
                        <th>Nit</th>
                        <th>Direccion</th>
                        <th>Tipo de Institucion</th>
                        <th>Municipio</th>
                        <th>Departamento</th>
                        <th>Fecha Acreditacion</th>
                        <th>Fecha Renovacion</th>
                        <th>Codigo Prestador</th>
                        <th>Telefono</th>
                        <th>Editar</th>
                      </tr>
                    </thead>
                    <tbody>
                      {list.map((item) => {
                        return (
                          <tr>
                            <td>{item.id}</td>
                            <td>{item.razon_Social}</td>
                            <td>{item.nit}</td>
                            <td>{item.direccion}</td>
                            <td>{item.tipo_Institucion}</td>
                            <td>{item.ciudad}</td>
                            <td>{item.departamento}</td>
                            <td>{item.fecha_acreditacion}</td>
                            <td>{item.fecha_renovacion}</td>
                            <td>{item.codigo_prestador}</td>
                            <td>{item.telefono}</td>
                            {cookie.get("institucionid") == 1 ? (
                              <td>
                                <InfoPerfil idInstitucion={item.id} />
                              </td>
                            ) : (
                              <td>
                                <EditarInstitucion
                                  idIntitucion={item.id}
                                  ciudad={item.ciudad}
                                  departamento={item.departamento}
                                  razonSocial={item.razon_Social}
                                  nit={item.nit}
                                  direccion={item.direccion}
                                  correo={item.correo}
                                  telefono={item.telefono}
                                  fecha_acreditacion={item.fecha_acreditacion}
                                  codigo_prestador={item.codigo_prestador}
                                  mision={item.mision}
                                  vision={item.vision}
                                  principios={item.principios}
                                  valores={item.valores}
                                  objetivosEstrategicos={
                                    item.objetivosEstrategicos
                                  }
                                  politicaSeguridad={item.politicaSeguridad}
                                />
                              </td>
                            )}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </MDBCollapse>
              <hr />
              <MDBBtn
                outline
                className="btn btn-light btn-user btn-block"
                onClick={toggleShow1}
              >
                <IoIcons.IoIosPaper /> <left>Cuestionario del perfil</left>
              </MDBBtn>
              <MDBCollapse show={showShow1}>
                {cookie.get("institucionid") != 1 ? (
                  <PerfilAutoevaluacio InstitucionId={Id} />
                ) : (
                  <h1></h1>
                )}
              </MDBCollapse>
              <hr />
              <MDBBtn
                outline
                className="btn btn-light btn-user btn-block"
                onClick={toggleShow2}
              >
                <IoIcons.IoIosPaper />{" "}
                <left>Información del perfil autoevaluación</left>
              </MDBBtn>
              <MDBCollapse show={showShow2}>
                {cookie.get("institucionid") != 1 ? (
                  <InfoPerfilInstitucion2
                    idInstitucion={cookie.get("institucionid")}
                  />
                ) : (
                  <h1></h1>
                )}
              </MDBCollapse>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
export default Instituciones;
